<template>
  <div>
    <template v-if="isQuestion">
      <div v-if="!subStep">
        {{ stepData.question.text }}
        <template v-if="stepData.question.type === 'choose-one'">
          <div 
            v-for="(option, index) in stepData.question.options" 
            :key="'step-op-' + index"
            class="custom-control custom-radio"
          >
            <input
              type="radio"
              :id="'step-op-' + index"
              :name="'step-ops'" 
              :value="option.value"
              class="custom-control-input"
              @change="selectOption(option)"
            />
            <label :for="'step-op-' + index" class="custom-control-label">{{ option.text }}</label>
          </div>
        </template>
      </div>

      <div v-if="subStep" style="padding: 1rem; background: #e3f4ff;">
        <component v-if="subStep" :is="stepComponent" v-on="$listeners" @select-suboption="selectSubOption" :component-data='subStep.component.data' />
      </div>
    </template>
    <template v-if="isMessage">
      <div class="question-text">
        {{ stepData.question.text }}
      </div>
      <div style="display: flex; justify-content: flex-end;">
        <GekkoButton 
          v-if="stepData.nextbutton"
          :text="stepData.nextbutton" 
          @click="$emit('next-step', false)"
          icon="fa-solid fa-arrow-right"
          icon-right
        />
      </div>
    </template>
  </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
export default {
  name: 'SurveyStep',
  components: {
    GekkoButton,
  },
  props: {
    stepData: {
      type: Object,
      default: () => {} 
    },
  },
  data () {
    return {
      subStep: null,
    }
  },
  computed: {
    isQuestion () { return this.stepData.type === 'question' },
    isMessage () { return this.stepData.type === 'message' },
    stepComponent () { return () => import(`@/components/ui/survey/${this.subStep.component.name}`) }
  },
  methods: {
    loadSubstep (async_component) {
      this.subStep = async_component
    },
    nextStep () {
      this.$emit('next-step', false)
    },
    prevStep () { this.$emit('prev-step', false) },
    selectOption (option) {
      this.$emit('save-answer', { id: this.stepData.id, value: option.value, text: this.stepData.question.short_text  })
      if (option.fn && option.fn.name) this.callFn(option.fn)
    },
    selectSubOption (option) {
      Object.values(option.answers).forEach(answer => {
        this.$emit('save-answer', answer)
      })
      if (option.fn && option.fn.name) this.callFn(option.fn)
    },
    callFn (fn) {
      if (this[fn.name]) this[fn.name](fn.params)
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
